import { Link } from 'react-router-dom';
import { FaTruck, FaPlane, FaTrain, FaShip } from 'react-icons/fa';
import { motion } from 'framer-motion';

const Services = () => {
  const services = [
    {
      id: 'road',
      title: 'Road Transport',
      description: 'Efficient road transportation solutions for domestic and cross-border logistics with real-time tracking.',
      icon: <FaTruck size={40} />,
      link: '/services#road'
    },
    {
      id: 'air',
      title: 'Air Freight',
      description: 'Express air freight services for time-sensitive shipments with global coverage and priority handling.',
      icon: <FaPlane size={40} />,
      link: '/services#air'
    },
    {
      id: 'train',
      title: 'Rail Transport',
      description: 'Sustainable and cost-effective rail freight solutions for bulk cargo and long-distance transportation.',
      icon: <FaTrain size={40} />,
      link: '/services#train'
    },
    {
      id: 'ship',
      title: 'Sea Freight',
      description: 'Comprehensive sea freight services including FCL, LCL, and specialized container solutions.',
      icon: <FaShip size={40} />,
      link: '/services#ship'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 }
    }
  };

  return (
    <section className="py-16 bg-white dark:bg-secondary-800">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-secondary-900 dark:text-white">Our Logistics Services</h2>
          <p className="max-w-2xl mx-auto text-secondary-600 dark:text-secondary-300">
            Comprehensive logistics solutions tailored to your specific needs, ensuring efficient and reliable transportation across all modes.
          </p>
        </div>

        <motion.div 
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {services.map((service) => (
            <motion.div 
              key={service.id}
              variants={itemVariants}
              className="bg-secondary-50 dark:bg-secondary-700 rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              <div className="text-primary-600 dark:text-primary-400 mb-4">
                {service.icon}
              </div>
              <h3 className="text-xl font-semibold mb-3 text-secondary-900 dark:text-white">
                {service.title}
              </h3>
              <p className="text-secondary-600 dark:text-secondary-300 mb-4">
                {service.description}
              </p>
              <Link 
                to={service.link}
                className="inline-block text-primary-600 dark:text-primary-400 font-medium hover:text-primary-700 dark:hover:text-primary-300 transition-colors"
              >
                Learn more →
              </Link>
            </motion.div>
          ))}
        </motion.div>

        <div className="text-center mt-12">
          <Link 
            to="/services"
            className="inline-block bg-primary-600 hover:bg-primary-700 text-white font-medium py-3 px-6 rounded-md transition-colors duration-300"
          >
            View All Services
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Services;